
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "7 façons efficaces d’améliorer la visibilité de votre site",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous avez créé votre site ? Découvrez 7 stratégies pour renforcer sa visibilité en ligne, attirer plus de visiteurs et maximiser votre impact sur le web.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "7 façons d’améliorer la visibilité de votre site Internet",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous avez créé votre site Internet et devez maintenant en assurer la visibilité. Cet article vous explique comment.",
        },
      ],
    };
  },
};
